import { render, staticRenderFns } from "./UpsellModal.vue?vue&type=template&id=458f5170&scoped=true&"
import script from "./UpsellModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./UpsellModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458f5170",
  null
  
)

export default component.exports